<template>
    <iframe ref="iframe" class="email-template-preview" />
</template>
<script setup>

    import { inject, onMounted, ref, watch } from 'vue';
    import { notifyError } from '../utils/notify';

    const http = inject('http');

    const props = defineProps({
        message: {
            type: String,
            required: true,
        },
    });

    const iframe = ref(null);
    const emailLayout = ref(null);

    watch(() => props.message, () => {
        setContent(props.message);
    });

    onMounted(async () => {
        await loadEmailLayout();
        setContent(props.message);
    });

    async function loadEmailLayout() {
        try {
            const response = await http.get('/api/company/email-layout');
            emailLayout.value = response.data.layout;
        } catch (exception) {
            notifyError(exception);
        }
    }

    function setContent(message) {
        if (!emailLayout.value?.length) {
            return;
        }

        iframe.value.contentWindow.document.open();
        iframe.value.contentWindow.document.write(emailLayout.value.replace(/\[\[INHOUD]]/g, message));
        iframe.value.contentWindow.document.close();
    }
</script>

<style lang="scss" scoped>

    .email-template-preview {
        width: 100%;
        height: 100%;
        min-height: 400px;
        border: none;
        padding: 0;
        margin: 0;
    }

</style>
